import React from 'react';
import { ArrowUpRight } from 'lucide-react';

const Hero: React.FC = () => {
  return (
    <section className="relative min-h-[70vh] flex flex-col items-center justify-center px-6 pt-32 sm:pt-40 pb-16 overflow-hidden">
      {/* Ambient background gradients */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-gold/[0.03] rounded-full blur-[120px] animate-pulse-slow" />
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-gold/[0.02] rounded-full blur-[100px] animate-pulse-slow" style={{ animationDelay: '1.5s' }} />
      </div>

      {/* Grid lines decoration */}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03]">
        <div className="w-full h-full" style={{
          backgroundImage: 'linear-gradient(rgba(212,175,55,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(212,175,55,0.3) 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }} />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        {/* Eyebrow */}
        <div className="inline-flex items-center gap-2 px-4 py-1.5 mb-8 rounded-full border border-gold/20 bg-gold/[0.05]">
          <span className="w-1.5 h-1.5 rounded-full bg-gold animate-pulse" />
          <span className="text-xs font-mono text-gold/80 tracking-widest uppercase">
            Digital Riyaz Studio
          </span>
        </div>

        {/* Headline */}
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight leading-[1.1] mb-6">
          <span className="text-white">Precision Engineering</span>
          <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold via-gold-bright to-gold gold-glow">
            for Classical Music
          </span>
        </h1>

        <p className="text-[17px] sm:text-xl text-neutral-400 max-w-3xl mx-auto leading-relaxed mb-10 font-light px-4 sm:px-0">
          A suite of high-fidelity instruments and practice tools built with the 
          <span className="text-neutral-300 font-medium"> Web Audio API</span>.
          <span className="block sm:inline sm:ml-1 mt-2 sm:mt-0">
            Zero latency. Studio-grade precision. Made for serious musicians.
          </span>
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#apps"
            className="group inline-flex items-center gap-2 px-8 py-3.5 rounded-xl bg-gold text-charcoal font-semibold text-sm tracking-wide hover:bg-gold-bright transition-all duration-300 hover:shadow-[0_0_30px_rgba(212,175,55,0.3)]"
          >
            Explore Tools
            <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
          <a
            href="https://manmitsinghmusic.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-xl border border-white/10 text-neutral-300 font-medium text-sm hover:border-gold/30 hover:text-gold transition-all duration-300"
          >
            Main Site
          </a>
        </div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-charcoal to-transparent pointer-events-none" />
    </section>
  );
};

export default Hero;
